import { memo } from 'react';
import { useState } from 'react';
import { TableCell, TableHead, TableRow, Typography, Button } from '@mui/material';
import AddIncoterm from './AddIncoterm';
import { Dialog } from '../../style-guide';

const IncotermHeader = () => {
    const [openOrderModal, setOpenOrderModal] = useState(false);
    const onHandleOpenModal = () => setOpenOrderModal(true);
    const onHandleCancelModal = () => setOpenOrderModal(false);

    return (
        <TableHead>
            <TableRow>
                <TableCell sx={4}>
                    <Typography variant='h7'>
                        
                    </Typography>
                </TableCell>
                <TableCell sx={4}>
                    <Typography variant='h7'>
                        Name
                    </Typography>
                </TableCell>
                <TableCell sx={4}>
                    <Typography variant='h7'>

                    </Typography>
                </TableCell>
                <TableCell sx={4}>
                    <Typography variant='h7'>
                        Operations 
                    </Typography>
                </TableCell>
                <TableCell sx={4}>
                    <Typography variant='h7'>
                        <Button onClick={onHandleOpenModal} variant='contained'>
                            + New Incoterm
                        </Button>
                        {openOrderModal && (
                            <Dialog open={openOrderModal} title={'Incoterm'} onHandleCancel={onHandleCancelModal}>
                                <AddIncoterm onHandleCancel={onHandleCancelModal} id={null} />
                            </Dialog>
                        )}
                    </Typography>
                </TableCell>

            </TableRow>
        </TableHead>
    );
};

export default memo(IncotermHeader);
